import React from 'react';
import {
  Text,
  NumberInput,
  Button,
  Group,
  Stack,
  Paper,
  Box,
} from '@mantine/core';
import VariantSelector from './VariantSelector';

export default function ProductDetailPurchaseCard({
  product,
  variants,
  selectedVariant,
  quantity,
  onQuantityChange,
  stockQuantity,
  isSoldOut,
  onAddToCart,
  addingToCart,
  addedToCart,
  onBuyNow,
  onVariantChange,
  previewMode = false,
  t,
}) {
  if (!selectedVariant) return null;

  // Preorder variants are never quantity-capped (soft-block);
  // non-preorder variants have a hard stock limit.
  const maxQuantity =
    isSoldOut || selectedVariant.can_preorder ? undefined : stockQuantity;

  return (
    <Paper p="xl" radius="lg" bg="blue.0" withBorder={false}>
      <Stack gap="md">
        {variants.length > 1 && (
          <VariantSelector
            variants={variants}
            selectedVariant={selectedVariant}
            onChange={onVariantChange}
          />
        )}
        {product.is_bulk_only ? (
          <Button
            size="xl"
            radius="xl"
            fullWidth
            color="blue"
            onClick={previewMode ? undefined : () => {}}
            tabIndex={previewMode ? -1 : undefined}
          >
            {t('contactForBulk', 'Contact for Inquiry')}
          </Button>
        ) : (
          <Stack gap="md">
            <Group align="flex-end" wrap="nowrap">
              <NumberInput
                label={<Text fw={700} size="xs" mb={5} tt="uppercase" lts={1}>{t('quantity', 'Quantity')}</Text>}
                value={quantity}
                onChange={previewMode ? undefined : onQuantityChange}
                min={1}
                max={maxQuantity}
                size="md"
                radius="md"
                w={100}
                readOnly={previewMode}
                disabled={isSoldOut}
                tabIndex={previewMode || isSoldOut ? -1 : undefined}
              />
              <Button
                size="md"
                radius="xl"
                flex={1}
                color={addedToCart ? "green" : "blue"}
                onClick={previewMode ? undefined : onAddToCart}
                loading={!previewMode && addingToCart}
                disabled={isSoldOut}
                tabIndex={previewMode || isSoldOut ? -1 : undefined}
              >
                {addedToCart ? t('addedToCart') : t('addToCart')}
              </Button>
            </Group>
            {!isSoldOut && quantity > Number(stockQuantity || 0) && (
              <Box role="status">
                <Text size="xs" c="orange.7" fw={800} tt="uppercase" lts={1}>
                  {t('stockShortfallTitle', 'Guaranteed Fresh & Crafted for You')}
                </Text>
                <Text size="xs" c="orange.7" fw={600}>
                  {t('stockShortfallNote', 'We make everything in small, exclusive batches to ensure the highest quality. Your order is secured for our next production run and will be shipped right after. Thank you for choosing fresh!')}
                </Text>
              </Box>
            )}
            <Button
              variant="light"
              color="blue"
              radius="xl"
              size="md"
              fullWidth
              onClick={previewMode ? undefined : onBuyNow}
              disabled={isSoldOut}
              tabIndex={previewMode || isSoldOut ? -1 : undefined}
            >
              {t('buyItNow', 'Buy It Now')}
            </Button>
          </Stack>
        )}
      </Stack>
    </Paper>
  );
}
